import React, { Component } from 'react';
import PropTypes from 'prop-types';

import CustomTable from '../../../components/customTable';

class SalaryTable extends Component {
  static propTypes = {
    tableDataSet: PropTypes.array.isRequired,
    customColumnConfig: PropTypes.object.isRequired,
    columnWidthBalanced: PropTypes.bool,
    hideRows: PropTypes.bool,
    showMoreText: PropTypes.string
  };

  render() {
    const {
      tableDataSet = [],
      customColumnConfig = {},
      columnWidthBalanced = true,
      hideRows = false,
      defaultRowsDisplay = 10,
      displayRowsPerExpand = 10,
      showMoreText
    } = this.props;
    return (
      <CustomTable
        columnConfig={customColumnConfig}
        columnWidthBalanced={columnWidthBalanced}
        bodyData={tableDataSet}
        defaultRowsDisplay={defaultRowsDisplay}
        displayRowsPerExpand={displayRowsPerExpand}
        hideRows={hideRows}
        showMoreText={showMoreText}
      />
    );
  }
}

export default SalaryTable;
